var map = {
	"./address-book.svg": "f161",
	"./affiche.svg": "9703",
	"./alert.svg": "da1e",
	"./alipay.svg": "4b4e",
	"./annotation.svg": "4133",
	"./bill.svg": "8c23",
	"./carrier.svg": "00ee",
	"./check.svg": "5ee6",
	"./close-keyboard.svg": "9cdb",
	"./contacts.svg": "9f10",
	"./credit.svg": "ad6a",
	"./cross.svg": "0135",
	"./debug.svg": "d709",
	"./delay-exam-0.svg": "10e3",
	"./delay-exam-1.svg": "c248",
	"./delay-exam-2.svg": "628f",
	"./delay-exam-3.svg": "fe8f",
	"./delay-exam-4.svg": "426d",
	"./empty-list.svg": "c9e0",
	"./identity.svg": "9af1",
	"./keyboard-delete.svg": "3d5a",
	"./link-arrow.svg": "a26d",
	"./myprofile-right-tips.svg": "dda8",
	"./nav-borrow.svg": "dad6",
	"./nav-orders.svg": "8db4",
	"./no-pass.svg": "b268",
	"./other.svg": "657d",
	"./profile.svg": "05de",
	"./progress.svg": "54b7",
	"./question.svg": "d7b5",
	"./success-check.svg": "4a8c",
	"./switch.svg": "1954",
	"./triangle-down-arrow.svg": "5be9",
	"./trumpet.svg": "390d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "77b4";